var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"main-background-gradient"}}),_c('v-content',[_c('router-view')],1),_c('v-footer',[_c('div',{staticClass:"footer"},[_vm._v("Copyright 2020 Espy Analytics, LLC")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }